module.exports = __webpack_public_path__ + "static/grafika8@2x-35bf27f5ca1cb9b91e25082a2ff3035f.png";